import {Component} from 'react';
import PropTypes from 'prop-types';
import './CustomiseCoverPageImagesTabContent.scss';
import CoverPagePreviewContainer from './CoverPagePreviewContainer';
import ImageGridItem from './ImageGridItem';
import {Button, Icon} from 'semantic-ui-react';
import CustomiseCoverPageImageUploadContainer from './CustomiseCoverPageImageUploadContainer';
import Slider from 'rc-slider';
import SliderHandle from './SliderHandle';
import ZoomedImageDragging from './imaging/ZoomedImageDragging';
import ImageUtils from '../lib/ImageUtils';

class CustomiseCoverPageImagesTabContent extends Component {

  static propTypes = {
    images: PropTypes.array.isRequired,
    selectedImage: PropTypes.object,
    type: PropTypes.string,
    onSelection: PropTypes.func.isRequired,
  };

  state = {
    imageLoaded: false,
  };

  componentDidMount() {
    this.scrollToSelection();
  }

  gridItems = () => {
    const {selectedImage: {src: selectedUrl}, images, type} = this.props;
    return images.map((img, index) => {
      const className = index % 2 === 0 ? 'even' : 'odd';
      const selected = selectedUrl === img.image || selectedUrl === img.thumbnail;
      return (
          <ImageGridItem
            key={`${type}-${index}`}
            className={className}
            selected={selected}
            src={img.thumbnail}
            onClick={(e) => !selected && this.onSelectionProxy(e, {
              selectedImage: {
                src: img.image,
                type,
                zoom: null,
                x: null,
                y: null,
              }
            })}
        />
      );
    });
  };

  onSelectionProxy = (e, {selectedImage = {}}) => {
    const {onSelection} = this.props;
    onSelection(e, {
      selectedImage,
    });
  };

  scrollToSelection = () => {
    const selectedItems = document.getElementsByClassName('image-item highlighted');
    if (selectedItems.length > 0) {
      selectedItems[0].scrollIntoView(true);

      const listColumn = document.getElementsByClassName('list-column');
      listColumn[0].scrollBy(0, -10);
    }
  };

  getState = () => {
    return this.state;
  };

  render() {
    const {selectedImage, type} = this.props;
    const {imageLoaded} = this.state;

    const featuredImageDragging = ZoomedImageDragging({
      selectedImage,
      getState: this.getState.bind(this),
      setState: this.setState.bind(this),
      onChange: this.onSelectionProxy.bind(this),
    });

    const previewZoom = 1.5;
    const previewParams = {
      width: 210 * previewZoom,
      height: 297 * previewZoom,
      selectedImage,
      resizeImageDimensions : {
        width: 470,
        height: 313,
      },
      featuredImageDragging,
    };

    return (
      <div className="container cover-page-images-modal-content">
        <div className="column left">
          <Button.Group className="actions" compact fluid size="mini">
            <div className="action deselect">
              <Button className="no-image-btn"
                      content="No Image"
                      icon={<Icon name={selectedImage.src ? undefined : 'checkmark'}/>}
                      onClick={e => this.onSelectionProxy(e, {
                        selectedImage: {
                          src: null,
                          type,
                          zoom: null,
                          x: null,
                          y: null,
                        }
                      })}
              />
            </div>
            <CustomiseCoverPageImageUploadContainer className="action upload" type={type} onUpload={(uploadedUri) => this.onSelectionProxy({}, {
              selectedImage: {
                src: uploadedUri,
                type,
                zoom: null,
                x: null,
                y: null,
              }
            })}/>
          </Button.Group>
          <ul className="list">
            {this.gridItems()}
          </ul>
        </div>
        <div className="column right">
          <div className="description">Preview with current selected image</div>
          <div className="svg-container">
            {imageLoaded &&
              <CoverPagePreviewContainer {...previewParams}/>
            } : {
              <img
                alt="cover-loader"
                src={selectedImage.src}
                style={{ visibility: 'hidden' }}
                onLoad={(e) => {
                  ImageUtils.cacheNaturalSize(selectedImage.src, e.target.naturalWidth, e.target.naturalHeight);
                  this.setState({imageLoaded: true});
                }}
              />
            }
          </div>
          <div className="footer">
            <div>
              <Slider
                  value={(selectedImage.zoom || 1) * 10}
                  handle={SliderHandle}
                  max={30}
                  min={10}
                  onChange={(value) => featuredImageDragging.onZoom(value / 10)}
              />
              <span className="description">
                Zoom and drag the cover image as desired.
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomiseCoverPageImagesTabContent;
